/* global H_WEB_MARGIN */
import { EventBus } from '@/behaviours/event-bus'
const UP = 1
const DOWN = 2
export default {

  name: 'ScrollBehaviour',

  data () {
    return {
      scrollPosY: 0,
      lastScrollPosY: 0,
      directionY: 0
    }
  },

  mounted () {
    console.log('behaviour mounted')
    let vm = this
    var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
    if (iOS === false) {
      window.addEventListener('scroll', () => {
        // e param if necessary
        //e.preventDefault()
        var scrollPosY = window.scrollY
        this.$store.state.currentScrollY = window.scrollY
        if (window.scrollY + 35 >= document.body.scrollHeight - document.body.offsetHeight) {
          EventBus.$emit('maxScrollY')
        }
        vm.fireScrollData(scrollPosY)
      })
    } else {
      window.addEventListener('scroll', () => {
        this.$store.state.currentScrollY = window.scrollY
        if (window.scrollY + (35 + H_WEB_MARGIN) >= document.body.scrollHeight - document.body.offsetHeight) {
          EventBus.$emit('maxScrollY')
        }
      })
    }

    EventBus.$on('resetScroll', () => {
      console.log('reset scroll')
      this.$store.state.currentScrollY = 0
      window.scrollTo(0,0)
      this.scrollPosY = 0
      this.lastScrollPosY = 0
      this.directionY = 0

    })
  },

  destroyed() {
    EventBus.$off('resetScroll')
  },

  methods: {
    fireScrollData (scrollPosY) {
      this.lastScrollPosY = this.scrollPosY
      this.scrollPosY = scrollPosY
      // this.changeScrollDirection()
      // console.log('emit scroll')
      this.emitScroll()
      //console.log(this.scrollPosY, this.lastScrollPosY, this.directionY)
    },

    changeScrollDirection () {
      if (this.scrollPosY > this.lastScrollPosY) {
        if (this.directionY !== UP) {
          this.directionY = UP
          this.emitChangeDirection()
        }
      } else {
        if (this.directionY !== DOWN) {
          this.directionY = DOWN
          this.emitChangeDirection()
        }
      }
    },

    emitScroll () {

      EventBus.$emit('srcollY', {oldY: this.lastScrollPosY, newY: this.scrollPosY} )
      // TODO x
    },

    emitChangeDirection () {
      EventBus.$emit('scrollDirectionY', this.directionY )
      // TODO x
    }


  }
}